import { useMemo } from "react";

export default function useActiveFilterTags({
  searchFilters,
  roles,
  prefectures,
}) {
  const activeFilterTags = useMemo(() => {
    const tags = [];

    // role tags
    if (searchFilters.roleIds?.length) {
      const selectedRoleIdSet = new Set(searchFilters.roleIds.map(String));

      const selectedRoles = roles.filter((role) =>
        selectedRoleIdSet.has(String(role.id))
      );

      selectedRoles.forEach((role) => {
        tags.push({
          key: `role:${role.id}`,
          label: role.name,
          type: "role",
          value: role.id,
        });
      });
    }

    // prefecture tags
    if (searchFilters.prefectureIds?.length) {
      const selectedPrefectureIdSet = new Set(
        searchFilters.prefectureIds.map(String)
      );

      const selectedPrefectureNames = prefectures
        .filter((prefecture) =>
          selectedPrefectureIdSet.has(String(prefecture.id))
        )
        .map((prefecture) => prefecture.name);

      selectedPrefectureNames.forEach((prefectureName) => {
        tags.push({
          key: `prefecture:${prefectureName}`,
          label: prefectureName,
          type: "prefecture",
          value: prefectureName,
        });
      });
    }

    // price tags
    const priceFilter = searchFilters.priceFilter;

    const hasPriceValue =
      priceFilter?.value != null && String(priceFilter.value).trim() !== "";

    if (hasPriceValue) {
      tags.push({
        key: `price:${priceFilter.value}`,
        label: `${priceFilter.value}万円`,
        type: "price",
        value: priceFilter.value,
      });
    }

    return tags;
  }, [searchFilters, roles, prefectures]);

  return { activeFilterTags };
}